// @ vendor
const React = require('react');
const PropTypes = require('prop-types');

// @ commons
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');

// @ utils
const { formatText } = require('core/i18n').i18n;

// @ components
const InsuranceRequestPlansHeaderCell = require('./insuranceRequestPlansHeaderCell');

const InsuranceRequestPlansHeader = props => {
    const {
        immInsuranceWizardStep,
        insuranceUsabilityImprovementsFlag,
        isColumnDisabled,
        onHandleHoverColumn,
        plansOrdered,
        titlePlans,
    } = props;

    const planCells = plansOrdered.map((plan, idx) => (
        <InsuranceRequestPlansHeaderCell
            column={idx}
            immInsuranceWizardStep={immInsuranceWizardStep}
            insuranceUsabilityImprovementsFlag={insuranceUsabilityImprovementsFlag}
            isColumnDisabled={isColumnDisabled}
            key={idx}
            onHandleHoverColumn={onHandleHoverColumn}
            plan={plan}
            title={titlePlans[idx]}
        />
    ));

    return (
        <OKTableRow asHeader={true} className="coverage-and-plans__table-row-header">
            <OKTableCell
                className="coverage-and-plans__table-cell coverage-and-plans__table-cell--title-rounded"
                asHeader={true}
            >
                <div className="coverage-and-plans__table-cell-title">
                    {formatText('insuranceRequestHome-step3CoveragesAndGuaranteesTableTitle')}
                </div>
            </OKTableCell>
            {planCells}
        </OKTableRow>
    );
};

InsuranceRequestPlansHeader.propTypes = {
    handleClickSelectPlan: PropTypes.func.isRequired,
    immInsuranceWizardStep: PropTypes.object.isRequired,
    insuranceUsabilityImprovementsFlag: PropTypes.bool.isRequired,
    isColumnDisabled: PropTypes.func.isRequired,
    onHandleHoverColumn: PropTypes.func.isRequired,
    plansOrdered: PropTypes.array.isRequired,
    titlePlans: PropTypes.array.isRequired,
};

module.exports = InsuranceRequestPlansHeader;
